module.exports = __webpack_public_path__ + "static/media/img-monterrey.eb554afb.jpg";